<template>
    <div class="mt-4">
        <b-row>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Primary">
                    <b-form-input v-model="insurance.primary"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Primary ID #">
                    <b-form-input v-model="insurance.primary_id"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Secondary">
                    <b-form-input v-model="insurance.secondary"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group
                        horizontal
                        :label-cols="2"
                        breakpoint="lg"
                        label="Secondary ID #">
                    <b-form-input v-model="insurance.secondary_id"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import {cloneDeep} from 'lodash';

  export default {
    props: {
      mode: {
        type: String,
        default: 'add'
      },
      patient: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
        insurance: {}
      }
    },

    created() {
      if (this.mode === 'edit') {
        const clonePatient = cloneDeep(this.patient);
        this.insurance = clonePatient.insurance ? clonePatient.insurance : {};
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Patient/Form/InsuranceForm.vue